import SDK from "../../../../src/components/sdk";
import * as React from 'react';
export default {
  SDK,
  React
};